import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { PatientRoutingModule } from './patient-routing.module';
import { LandingComponent } from './landing/landing.component';
import { SearchNearbyFacilityComponent } from './search-nearby-facility/search-nearby-facility.component';
import { ConfirmDateTimeSlotComponent } from './confirm-date-time-slot/confirm-date-time-slot.component';
import { AppointmentConfirmationComponent } from './appointment-confirmation/appointment-confirmation.component';
import { CheckboxModule } from 'primeng/checkbox';
import { SharedModule } from '../shared/shared.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { TabViewModule } from 'primeng/tabview';
import { MultiSelectModule } from 'primeng/multiselect';
import { ButtonModule } from 'primeng/button';
import { DialogModule } from 'primeng/dialog';
import { RadioButtonModule } from 'primeng/radiobutton';
import { InputSwitchModule } from 'primeng/inputswitch';
import { TextareaModule } from 'primeng/textarea';
import { CalendarModule as inlineCalendar } from 'primeng/calendar';
import { ToastModule } from 'primeng/toast';
import { ProgressSpinnerModule } from 'primeng/progressspinner';

import { NgxDaterangepickerMd } from 'ngx-daterangepicker-material';
import { SidebarModule } from 'primeng/sidebar';
import { AppointmentSummaryComponent } from './appointment-summary/appointment-summary.component';
import { RescheduleAppointmentComponent } from './reschedule-appointment/reschedule-appointment.component';
import { ProgressBarModule } from 'primeng/progressbar';
import { CancelledComponent } from './cancelled/cancelled.component';
import { PatientAppointmentBookingComponent } from './patient-appointment-booking/patient-appointment-booking.component';
import { TooltipModule } from 'primeng/tooltip';
import { PayBookAppointmentComponent } from './pay-book-appointment/pay-book-appointment.component';

@NgModule({
  declarations: [
    LandingComponent,
    SearchNearbyFacilityComponent,
    ConfirmDateTimeSlotComponent,
    AppointmentConfirmationComponent,
    AppointmentSummaryComponent,
    RescheduleAppointmentComponent,
    CancelledComponent,
    PatientAppointmentBookingComponent,
    PayBookAppointmentComponent
  ],
  exports: [
    CheckboxModule,
    SharedModule,
    FormsModule,
    TabViewModule,
    MultiSelectModule,
    ButtonModule,
    DialogModule,
    TooltipModule,
    RadioButtonModule,
    InputSwitchModule,
    TextareaModule,
    inlineCalendar,
    ToastModule,
    SidebarModule,
    ProgressBarModule
  ],
  imports: [
    CommonModule,
    PatientRoutingModule,
    CheckboxModule,
    SharedModule,
    FormsModule,
    ReactiveFormsModule,
    TabViewModule,
    TooltipModule,
    MultiSelectModule,
    ButtonModule,
    DialogModule,
    RadioButtonModule,
    InputSwitchModule,
    TextareaModule,
    inlineCalendar,
    ToastModule,
    ProgressSpinnerModule,
    SidebarModule,
    ProgressBarModule,
    NgxDaterangepickerMd.forRoot({
      applyLabel: 'Okay',
      firstDay: 3
    })
  ],
  providers: [provideHttpClient(withInterceptorsFromDi())]
})
export class PatientModule {}
